import { webClient } from "@shared/apis"
import { SECOND } from "@shared/constants"

/**
 * 적립 요청이 응답 없이 멈추는 것을 막는다.
 * 서버는 페이레터 호출(5초 타임아웃 + 재시도)이 끝날 때까지 응답하지 못할 수 있어 넉넉하게 잡는다.
 * 시간이 지나면 "응답 없음" 에러가 되어 같은 키로 재시도한다
 */
const ADD_TIMEOUT = 30 * SECOND

const WowMoneyApi = {
  /** 같은 적립 시도의 재요청은 같은 idempotencyKey 를 보내야 서버가 중복으로 본다 */
  add: (idempotencyKey: string) =>
    webClient.post<WowMoney>("/coins", undefined, {
      headers: { "Idempotency-Key": idempotencyKey },
      timeout: ADD_TIMEOUT,
    }),
  currentPrice: () => webClient.get<number>("/coins/current_price"),
}

export default WowMoneyApi

interface WowMoney {
  id: number
  scheduleId: number
  streamerName: string
  username: string
  /** 이번에 적립된 금액. 실패하면 0 */
  price: number
  /** 이번 달 누적 적립액 */
  cumulativePrice: number
  isSuccess: boolean
  /** 서버 자체 결과 코드. HTTP 상태 코드와 다르다 (예: 1003 존재하지 않는 회원) */
  statusCode: number
  /** 요청한 Idempotency-Key. 서버 로그와 대조할 때 쓴다 */
  transactionId: string
  /** 실패 사유. 사용자에게 그대로 보여줄 수 있는 문구 */
  message: string
  details: string
  createdId: string
  createdAt: string
  updatedAt: string
}
